import { values } from './enums'

const DueDateMonthly = {
  FROM_START: 0,
  TILL_END: 1,
  PAST_END: 2,
  DAY_OF_MONTH: 3
}

const VALUES = values(DueDateMonthly)

export {
  DueDateMonthly,
  VALUES
}



// WEBPACK FOOTER //
// ./src/enums/DueDateMonthly.js